'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _radium = require('radium');

var _radium2 = _interopRequireDefault(_radium);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (_typeof(call) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + _typeof(superClass));
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var styles = {
  background: {
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    color: '#fff'
  }
};

var CardWrapper = function (_React$Component) {
  _inherits(CardWrapper, _React$Component);

  function CardWrapper(props) {
    _classCallCheck(this, CardWrapper);

    var _this = _possibleConstructorReturn(this, (CardWrapper.__proto__ || Object.getPrototypeOf(CardWrapper)).call(this, props));

    _this.state = {};
    return _this;
  }

  _createClass(CardWrapper, [{
    key: 'dimension',
    value: function dimension() {
      return {
        width: this.props.width || 'auto',
        height: this.props.height || 'auto'
      };
    }
  }, {
    key: 'padding',
    value: function padding() {
      return {
        padding: this.props.padding || '50px 40px'
      };
    }
  }, {
    key: 'background',
    value: function background() {
      if (this.props.imageUrl) {
        return {
          backgroundImage: 'url(' + this.props.imageUrl + ')'
        };
      } else if (this.props.backgroundColor) {
        return {
          backgroundColor: this.props.backgroundColor
        };
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2["default"].createElement('div', {
        style: [styles.background, this.background(), this.dimension(), this.padding(), this.props.customStyles]
      }, this.props.children);
    }
  }]);

  return CardWrapper;
}(_react2["default"].Component);

;
var component = (0, _radium2["default"])(CardWrapper);
exports["default"] = {
  component: component
};